import Exercise from '../pages/mental/Exercise.vue'
import Router from "vue-router";
import store1 from "../store/index.js";

import Landing from "../pages/common-apps/Landing.vue";

const baseRoutes = [
  {
    path: '/',
    redirect: { name: 'Landing' }
  },
  {
    path: '/landing',
    name: 'Landing',
    component: Landing,
    meta: { bodyClass: 'landing-page' }
  },
  {
    path: `/articles`,
    name: 'Article',
    component: () => import(/* webpackChunkName: "article" */ "../pages/common-apps/Article.vue"),
    // component: Article,
    meta: { bodyClass: 'month-page', requiresAuth: true }
  },
  {
    path: `/articles/:year`,
    name: 'Article1',
    component: () => import(/* webpackChunkName: "article" */ "../pages/common-apps/Article.vue"),
    // component: Article,
    meta: { bodyClass: 'month-page', requiresAuth: true }
  },
  {
    path: `/articles/bycat/:catid`,
    name: 'Article2',
    component: () => import(/* webpackChunkName: "article" */ "../pages/common-apps/Article.vue"),
    // component: Article,
    meta: { bodyClass: 'month-page', requiresAuth: true }
  },
  {
    path: `/articles/search/:type/:term`,
    name: 'Article5',
    component: () => import(/* webpackChunkName: "article" */ "../pages/common-apps/Article.vue"),
    // component: Article,
    meta: { bodyClass: 'month-page', requiresAuth: true }
  },
  {
    path: `/articles/:year/:month1`,
    name: 'Article3',
    component: () => import(/* webpackChunkName: "article" */ "../pages/common-apps/Article.vue"),
    // component: Article,
    meta: { bodyClass: 'month-page', requiresAuth: true }
  },
  {
    path: `/articles/:year/:month1/:day`,
    name: 'Article4',
    component: () => import(/* webpackChunkName: "article" */ "../pages/common-apps/Article.vue"),
    // component: Article,
    meta: { bodyClass: 'month-page', requiresAuth: true }
  },
  {
    path: `/article-details/:id`,
    name: 'ArticleDetails',
    component: () => import(/* webpackChunkName: "articledetails" */ "../pages/common-apps/ArticleDetails.vue"),
    // component: ArticleDetails,
    meta: { bodyClass: 'month-page', requiresAuth: true }
  }
] // to comment Landing route when using on dev mode

const mentalRoutes = [
  {
    path: '/exercises',
    name: 'Exercise',
    component: Exercise,
    meta: { bodyClass: 'month-page', requiresAuth: true }
  },
  {
    path: '/exercises/:id',
    name: 'Exercise1',
    component: () => import(/* webpackChunkName: "exercisedetails" */ "../pages/mental/ExerciseDetails.vue"),
    // component: ExerciseDetails,
    meta: { bodyClass: 'month-page', requiresAuth: true }
  },
  {
    path: '/emotions',
    name: 'Emotion',
    component: () => import(/* webpackChunkName: "emotion" */ "../pages/mental/Emotion.vue"),
    // component: Emotion,
    meta: { bodyClass: 'month-page', requiresAuth: true }
  },
  {
    path: '/plusminus',
    name: 'PlusMinus',
    component: () => import(/* webpackChunkName: "plusminus" */ "../pages/mental/PlusMinus.vue"),
    // component: Emotion,
    meta: { bodyClass: 'month-page', requiresAuth: true }
  },
  {
    path: '/plusminus/:id',
    name: 'PlusMinus Details',
    component: () => import(/* webpackChunkName: "plusminusdetails" */ "../pages/mental/PlusMinusDetails.vue"),
    // component: Emotion,
    meta: { bodyClass: 'month-page', requiresAuth: true }
  },
  {
    path: '/courses',
    name: 'Mental Courses',
    component: () => import(/* webpackChunkName: "courses" */ "../pages/mental/Course.vue"),
    meta: { bodyClass: 'month-page', requiresAuth: true }
  },
  {
    path: '/courses/:id',
    name: 'Mental Courses Details',
    component: () => import(/* webpackChunkName: "coursedetails" */ "../pages/mental/CourseDetails.vue"),
    // component: TicketDetails,
    meta: { bodyClass: 'month-page', requiresAuth: true }
  },
]

const routes = baseRoutes.concat(mentalRoutes)


const routerMental = new Router({
  routes,
  base:'men',
  mode: 'history'
})

routerMental.beforeEach((to, from, next) => {
  // vueBodyClass.guard(to, next)
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store1.getters['account/isAuthenticated']) {
      next()
      return
    }
    next('/landing')
  } else {
    next()
  }
})

export default routerMental
